export const phoneValidator = (_: any, value: string) => {
  if (!value || !/^\d{10}$/.test(value)) {
    return Promise.reject("Phone number must be exactly 10 digits long");
  }
  const validPrefixes = ["97798", "97797", "97796"];
  const startsWithValidPrefix = validPrefixes.some((prefix) => value.startsWith(prefix.substring(3)));

  if (!startsWithValidPrefix) {
    return Promise.reject("Invalid Nepali phone number (must start with 98, 97, or 96)");
  }

  return Promise.resolve();
};
